import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import { Field, FieldArray } from 'redux-form';

import Input from '../input';
import Icon, { GLYPHS } from '../../common/icon';
import { canUserModifySchedules, canUserModifyBarbers } from '../helpers/users';
import ScheduleRow from './scheduleRow';
import withPermissions from '../../auth/utils/withPermissions';
import { t } from '../../../modules/infra/i18n';

const SchedulePeriod = (props) => {
  const {
    name,
    isActive,
    times,
    schedules,
    permissions,
  } = props;

  const wrapperClass = classNames('c-wrapper-for-schedule', {
    'is-hidden': !isActive,
  });

  const canModify = canUserModifySchedules(permissions) && canUserModifyBarbers(permissions);

  const conflicts = get(props, `${name}.conflicts`, []) || [];

  return (
    <div className={wrapperClass}>
      <Field name={`${name}.id`} component="input" type="hidden" />
      <div className="c-form-input-group u-mb">
        <div className="c-form-input-group__item u-position-relative">
          <div className="c-label">{t('barber:schedule.starting_date')}</div>
          <div className="o-calendar-icon">
            <Icon glyph={GLYPHS.calendar} />
          </div>
          <Input
            type="text"
            name={`${name}.startDate`}
            className="c-btn-calendar c-btn-calendar--first"
            schedules={schedules}
            datepicker={{ clearBtn: name === 'schedules.future' }}
            disabled={!canModify}
          />
        </div>
        <div className="c-form-input-group__item u-position-relative">
          <div className="c-label">{t('barber:schedule.ending_date')}</div>
          <div className="o-calendar-icon">
            <Icon glyph={GLYPHS.calendar} />
          </div>
          <Input
            type="text"
            name={`${name}.endDate`}
            className="c-btn-calendar c-btn-calendar--last"
            schedules={schedules}
            datepicker={{ clearBtn: true }}
            disabled={!canModify}
          />
        </div>
      </div>
      <FieldArray
        times={times}
        name={`${name}.workdays`}
        component={ScheduleRow}
        conflicts={conflicts}
        disabled={!canUserModifySchedules(permissions)}
      />
    </div>
  );
};

SchedulePeriod.propTypes = {
  name: PropTypes.string.isRequired,
  times: PropTypes.array.isRequired,
  isActive: PropTypes.bool.isRequired,
  schedules: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
};

export default withPermissions(SchedulePeriod);
